import React from 'react'
import { Tooltip, Button } from 'element-react'

const TooltipSG = () => {
    return (
        <div>
            <div>
                <Tooltip
                    className="demo-item"
                    effect="dark"
                    content="Top Left prompts info"
                    placement="top-start"
                >
                    <Button
                        type="secondary"
                        className="margin-right-small margin-bottom-small"
                    >
                        top-start
                    </Button>
                </Tooltip>
                <Tooltip
                    className="demo-item"
                    effect="dark"
                    content="Top Center prompts info"
                    placement="top"
                >
                    <Button
                        type="secondary"
                        className="margin-right-small margin-bottom-small"
                    >
                        top
                    </Button>
                </Tooltip>
                <Tooltip
                    className="demo-item"
                    effect="dark"
                    content="Top Right prompts info"
                    placement="top-end"
                >
                    <Button type="secondary" className="margin-bottom-small">
                        top-end
                    </Button>
                </Tooltip>
            </div>
            <div>
                <Tooltip
                    className="demo-item"
                    effect="dark"
                    content="Left Top prompts info"
                    placement="left-start"
                >
                    <Button
                        type="secondary"
                        className="margin-right-small margin-bottom-small"
                    >
                        left-start
                    </Button>
                </Tooltip>
                <Tooltip
                    className="demo-item"
                    effect="dark"
                    content="Left Center prompts info"
                    placement="left"
                >
                    <Button
                        type="secondary"
                        className="margin-right-small margin-bottom-small"
                    >
                        left
                    </Button>
                </Tooltip>
                <Tooltip
                    className="demo-item"
                    effect="dark"
                    content="Left Bottom prompts info"
                    placement="left-end"
                >
                    <Button
                        type="secondary"
                        className="margin-right-small margin-bottom-small"
                    >
                        left-end
                    </Button>
                </Tooltip>
                <Tooltip
                    className="demo-item"
                    effect="dark"
                    content="Right Top prompts info"
                    placement="right-start"
                >
                    <Button
                        type="secondary"
                        className="margin-right-small margin-bottom-small"
                    >
                        right-start
                    </Button>
                </Tooltip>
                <Tooltip
                    className="demo-item"
                    effect="dark"
                    content="Right Center prompts info"
                    placement="right"
                >
                    <Button
                        type="secondary"
                        className="margin-right-small margin-bottom-small"
                    >
                        right
                    </Button>
                </Tooltip>
                <Tooltip
                    className="demo-item"
                    effect="dark"
                    content="Right Bottom prompts info"
                    placement="right-end"
                >
                    <Button type="secondary" className="margin-bottom-small">
                        right-end
                    </Button>
                </Tooltip>
            </div>
            <div>
                <Tooltip
                    className="demo-item"
                    effect="dark"
                    content="Bottom Left prompts info"
                    placement="bottom-start"
                >
                    <Button
                        type="secondary"
                        className="margin-right-small margin-bottom-small"
                    >
                        bottom-start
                    </Button>
                </Tooltip>
                <Tooltip
                    className="demo-item"
                    effect="dark"
                    content="Bottom Center prompts info"
                    placement="bottom"
                >
                    <Button
                        type="secondary"
                        className="margin-right-small margin-bottom-small"
                    >
                        bottom
                    </Button>
                </Tooltip>
                <Tooltip
                    className="demo-item"
                    effect="dark"
                    content="Bottom Right prompts info"
                    placement="bottom-end"
                >
                    <Button type="secondary" className="margin-bottom-small">
                        bottom-end
                    </Button>
                </Tooltip>
            </div>
        </div>
    )
}

export default TooltipSG
